import mixpanelImport from 'mixpanel-browser'

export const mixpanel = mixpanelImport
